module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "progress-product"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "data-box"
  }, [_c('nav-component', {
    attrs: {
      "type": _vm.type,
      "currentType": _vm.rankType
    },
    on: {
      "changeNavType": _vm.changeNavType
    }
  }), _vm._v(" "), _c('table-component', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "tableInfo": _vm.tableInfo
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6fa9dd0","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/menpiao/productData/components/progress-product/ProgressProduct.vue
// module id = 847
// module chunks = 0